// extracted by mini-css-extract-plugin
export default {"cellActions":"CellActions_cellActions__L711X","cellActions--wide":"CellActions_cellActions--wide__Kzlz1"};